<template>
  <div class="enrolling-admission-offline">
    <div class="date-set-container" v-loading="loading" element-loading-text="数据加载中，请稍等...">
      <div class="date-set-title">
        <span>录取上报时间{{disabled ? '' : '设置'}}</span>
      </div>
      <div class="date-set-content">
        <div class="date-set-form-list">
          <div class="date-set-form">
            <span class="date-set-label">线上生录取阶段</span>
            <el-date-picker
              v-model="dateSettings.online"
              class="date-picker"
              size="mini"
              type="datetimerange"
              :disabled="disabled"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format = "yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </div>
          <div class="date-set-form">
            <span class="date-set-label">递补录取阶段</span>
            <el-date-picker
              v-model="dateSettings.supplement"
              class="date-picker"
              size="mini"
              type="datetimerange"
              :disabled="disabled"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format = "yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </div>
        </div>
        <el-button class="date-set-submit" type="primary" size="mini" @click="updateDate" :loading="committing" v-if="!disabled">确认</el-button>
      </div>
    </div>
    <div class="main-container">
      <PlatDataPanelSelect class="enrolling-admission-offline-site"
                           :custom-id="customId"
                           :data-types="['site']"
                           site-group
                           siteLabel="选择教学点">
        <template #default="scope">
          <keep-alive>
            <TemplateDataGrid :key="`${scope.site}`"
                              gridId="EnrollAdmissionScoreLineStudentGrid"
                              studentType="MBA"
                              type="offline"
                              v-bind="scope"></TemplateDataGrid>
          </keep-alive>
        </template>
      </PlatDataPanelSelect>
    </div>
  </div>
</template>

<script>
import PlatDataPanelSelect from '../../../wrapper/panel/PlatDataPanelSelect'
import TemplateDataGrid from '../../../../../../templates/TemplateDataGrid'
import routeConfig from '../../../../../../../constants/routeConfig'
export default {
  name: 'EnrollingAdmissionOffline',
  components: {
    PlatDataPanelSelect,
    TemplateDataGrid
  },
  data () {
    return {
      customId: '',
      loading: false,
      committing: false,
      disabled: false,
      dateSettings: {
        online: [],
        supplement: []
      }
    }
  },
  methods: {
    resolveDateSetting (data, keys) {
      let matchKey = keys.find(key => data[key])
      return matchKey ? data[matchKey] : []
    },
    loadData () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/enrolling/admission/scoreLineStudent/queryReportDate',
        method: 'post',
        data: this.$qs.stringify({
          studentType: 'MBA'
        })
      }).then((response) => {
        switch (response.data['responseCode']) {
          case 'SUCCESS': {
            this.dateSettings.online = this.resolveDateSetting(response.data, ['onlineDateSetting'])
            this.dateSettings.supplement = this.resolveDateSetting(response.data, ['supplementDateSetting', 'offlineDateSetting'])
            this.disabled = response.data['disabled']
            break
          }
          default: {
            this.$message.warning(response.data['message'])
            break
          }
        }
      }, () => {
        this.$message.error('请求发送失败')
      }).finally(() => {
        this.loading = false
      })
    },
    updateDate () {
      this.committing = true
      this.$ajax({
        url: '/workspace/manager/enrolling/admission/scoreLineStudent/updateReportDate',
        method: 'post',
        data: this.$qs.stringify({
          studentType: 'MBA',
          onlineDateSetting: this.dateSettings.online,
          supplementDateSetting: this.dateSettings.supplement
        }, {arrayFormat: 'repeat'})
      }).then((response) => {
        switch (response.data['responseCode']) {
          case 'SUCCESS': {
            this.$message.success(response.data['message'])
            break
          }
          default: {
            this.$message.warning(response.data['message'])
            break
          }
        }
      }, () => {
        this.$message.error('请求发送失败')
      }).finally(() => {
        this.committing = false
      })
    }
  },
  created () {
    this.customId = this.$route.params[routeConfig.DataTile.param]
  },
  mounted () {
    this.loadData()
  },
  activated () {
    this.loadData()
  }
}
</script>

<style lang="scss">
.enrolling-admission-offline {
  height: 100%;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  & > .date-set-container {
    height: 150px;
    padding: 0 15px;
    border-bottom: 1px solid #ebeef5;
    & > .date-set-title {
      font-size: 15px;
      height: 46px;
      line-height: 46px;
    }
    & > .date-set-content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .date-set-form {
        display: flex;
        align-items: center;
        & + .date-set-form {
          margin-top: 8px;
        }
        .date-set-label {
          width: 110px;
          font-size: 13px;
          color: #606266;
        }
        .date-picker {
          width: 360px;
        }
      }
      .date-set-submit {
        margin-left: 20px;
      }
    }
  }
  & > .main-container {
    flex: 1;
  }
}
</style>
